import { render, staticRenderFns } from "./IdentificationStep.vue?vue&type=template&id=5c2afbb4&"
import script from "./IdentificationStep.vue?vue&type=script&lang=js&"
export * from "./IdentificationStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports